import { render, staticRenderFns } from "./patients-popup.vue?vue&type=template&id=3aacbbeb&scoped=true"
import script from "./patients-popup.vue?vue&type=script&lang=js"
export * from "./patients-popup.vue?vue&type=script&lang=js"
import style0 from "./patients-popup.vue?vue&type=style&index=0&id=3aacbbeb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aacbbeb",
  null
  
)

export default component.exports